<template>
  <div class="container">
    <div class="notFound-header">
      <div class="notFound-header-head">
        <h1 class="entry-title" v-text="$t('route.notFound')" />
      </div>
      <div class="notFound-header-breadcrumbs">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }" v-text="$t('route.home')" />
            </li>
            <li class="breadcrumb-item active" aria-current="page" v-text="'Error 404'"></li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="notFound-main">
      <h2>Oops! That page can’t be found.</h2>
      <p>It looks like nothing was found at this location</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notFound'
}
</script>
<style lang="scss">
.notFound-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &-head {
    color: #2ba349;
    .entry-title {
      font-size: 52px;
      line-height: 62px;
    }
  }
  &-breadcrumbs {
    .breadcrumb {
      font-weight: 300;
      color: #adb0b6;
      font-size: 13px;
      line-height: 25px;
      text-transform: none;
      background-color: transparent;
      padding: 3px 12px 2px 12px;
      margin: 0;
      &-item {
        &.active,
        &::before {
          color: #adb0b6;
        }
      }
      a {
        color: #adb0b6;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
.notFound-main {
  padding: 70px 0;
  color: #787d85;
  font-weight: 300;
  text-align: center;
  h2 {
    color: #3b3f4a;
  }
}
</style>
